import RouterSection from '@/Layout/components/RouterSection';
import { checkAuthorization, subMemberCheckAuthorizationMaster } from '../NavigationGuards';

export default {
	path: '/mybiz',
	name: 'mybiz_home',
	component: RouterSection,
	mode: 'history',
	children: [
		// 마이비즈
		{
			path: '/',
			redirect: { name: 'bizmain' },
		},
		// 마이비즈
		{
			path: 'bizmain',
			name: 'bizmain',
			component: () => import('@/views/mybiz/Bizmain'),
			beforeEnter: checkAuthorization,
		},
		// 마이비즈 - 등급 안내
		{
			path: 'bizmainrating',
			name: 'bizmainrating',
			component: () => import('@/views/mybiz/Bizmain/BizmainRating'),
			beforeEnter: checkAuthorization,
		},
		// 구매관리 - 목록
		{
			path: 'prchmng',
			name: 'prchmng',
			component: () => import('@/views/mybiz/Purchase'),
			beforeEnter: checkAuthorization,
		},
		// 구매관리 - 기간거래 명세서
		{
			path: 'prchmng/periodtransaction',
			name: 'prchmngperiodtransaction',
			component: () => import('@/views/mybiz/Purchase/PeriodTransaction'),
			beforeEnter: checkAuthorization,
		},
		// 구매관리 - 상세
		{
			path: 'prchmng/:orderNo',
			name: 'prchmngdetail',
			component: () => import('@/views/mybiz/Purchase/Detail'),
			props: true,
			beforeEnter: checkAuthorization,
		},
		// 구매관리 - 거래명세서
		{
			path: 'prchmng/:orderNo/transaction',
			name: 'prchmngdetailtransaction',
			component: () => import('@/views/mybiz/Purchase/Transaction'),
			props: true,
			beforeEnter: checkAuthorization,
		},
		// 구매관리 - 쿠폰별 취소
		{
			path: 'prchmng/:orderNo/couponcancel',
			name: 'prchmngcouponcancel',
			component: () => import('@/views/mybiz/Purchase/CouponCancel'),
			props: true,
			beforeEnter: checkAuthorization,
		},
		// 메시지 미리보기
		{
			path: 'prchmng/:orderNo/message',
			name: 'prchmngmessage',
			component: () => import('@/views/mybiz/Purchase/MessageViewer'),
			props: route => ({ orderNo: route.params?.orderNo, isKakao: false }),
			beforeEnter: checkAuthorization,
		},
		// 알림톡 미리보기
		{
			path: 'prchmng/:orderNo/kakaomessage',
			name: 'prchmngkakaomessage',
			component: () => import('@/views/mybiz/Purchase/MessageViewer'),
			props: route => ({ orderNo: route.params?.orderNo, isKakao: true }),
			beforeEnter: checkAuthorization,
		},
		// 비즈머니관리
		{
			path: 'bizmnmng',
			name: 'bizmnmng',
			component: () => import('@/views/mybiz/BizmnMng'),
			beforeEnter: checkAuthorization,
		},
		// 비즈머니관리 - 거래명세서
		{
			path: 'bizmntransactionbill',
			name: 'bizmntransactionbill',
			component: () => import('@/views/mybiz/BizmnMng/TransactionBill'),
			beforeEnter: checkAuthorization,
		},
		// 비즈머니관리 - 비즈머니충전
		{
			path: 'bizmncharge',
			name: 'bizmncharge',
			component: () => import('@/views/mybiz/BizmnMng/BizmnCharge'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 비즈머니관리 - 비즈머니충전 완료 - 가상계좌
		{
			path: 'bizmnchargeendacc',
			name: 'bizmnchargeendacc',
			component: () => import('@/views/mybiz/BizmnMng/BizmnChargeEndAcc'),
			beforeEnter: checkAuthorization,
		},
		// 비즈머니관리 - 비즈머니충전 완료 - 전용계좌
		{
			path: 'bizmnchargeendprivate',
			name: 'bizmnchargeendprivate',
			component: () => import('@/views/mybiz/BizmnMng/BizmnChargeEndPrivate'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 비즈머니관리 - 비즈머니충전 완료 - 카드, 계좌이체
		{
			path: 'bizmnchargeend',
			name: 'bizmnchargeend',
			component: () => import('@/views/mybiz/BizmnMng/BizmnChargeEnd'),
			beforeEnter: checkAuthorization,
		},
		// 비즈머니관리 - 환불신청
		{
			path: 'bizmnrefund',
			name: 'bizmnrefund',
			component: () => import('@/views/mybiz/BizmnMng/BizmnRefund'),
			props: true,
			beforeEnter: checkAuthorization,
		},
		// 발신번호관리
		{
			path: 'fwnbmng',
			name: 'fwnbmng',
			component: () => import('@/views/mybiz/FwNbMng'),
			beforeEnter: checkAuthorization,
		},
		{
			path: 'fwnbmng/add',
			name: 'fwnbmngadd',
			component: () => import('@/views/mybiz/FwNbMng/Add'),
			beforeEnter: checkAuthorization,
			children: [
				{
					path: 'mobile',
					component: () => import('@/views/mybiz/FwNbMng/AddMobile'),
				},
				{
					path: 'tel',
					component: () => import('@/views/mybiz/FwNbMng/AddTel'),
				},
			],
		},
		// 서브회원관리
		{
			path: 'submemberlist',
			name: 'submemberlist',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberList'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 서브회원관리 - 등록
		{
			path: 'submemberregist',
			name: 'submemberregist',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberRegist'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 서브회원관리 - 상세
		{
			path: 'submemberdetail',
			name: 'submemberdetail',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberDetail'),
			props: true,
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 서브회원관리 - 구매관리
		{
			path: 'submembergorder',
			name: 'submembergorder',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberGOrder'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 서브회원관리 - 회원탈퇴
		{
			path: 'submemberwdrw',
			name: 'submemberwdrw',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberWdrw'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 서브회원관리 - 비즈머니 부여/회수
		{
			path: 'submemberbizmoneyinjection',
			name: 'submemberbizmoneyinjection',
			component: () => import('@/views/mybiz/SubUserMng/SubMemberBizMoneyInjection'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 문자메시지관리
		{
			path: 'txtmsgbanner',
			name: 'txtmsgbanner',
			component: () => import('@/views/mybiz/TxtmsgMngBanner'),
			redirect: '/mybiz/txtmsgbanner/image',
			beforeEnter: checkAuthorization,
			children: [
				{
					path: 'image',
					component: () => import('@/views/mybiz/TxtmsgMngBanner/ImageManager'),
				},
				{
					path: 'message',
					component: () => import('@/views/mybiz/TxtmsgMngBanner/MessageManager'),
				},
			],
		},
		// 문자메시지등록
		{
			path: 'txtmsgmng',
			name: 'txtmsgmng',
			component: () => import('@/views/mybiz/TxtmsgMngRegit'),
			beforeEnter: checkAuthorization,
		},
		// 회원정보관리 - 비밀번호 입력
		{
			path: 'memberinfologin',
			name: 'memberinfologin',
			component: () => import('@/views/mybiz/MemberInfo/MemberInfoLogin'),
			beforeEnter: checkAuthorization,
		},
		// 회원정보관리
		{
			path: 'memberinfomng',
			name: 'memberinfomng',
			props: true,
			component: () => import('@/views/mybiz/MemberInfo/MemberInfoMng'),
			beforeEnter: checkAuthorization,
		},
		// 회원정보관리 - 탈퇴
		{
			path: 'memberwdrw',
			name: 'memberwdrw',
			props: true,
			component: () => import('@/views/mybiz/MemberInfo/MemberInfoWithdrawal'),
			beforeEnter: checkAuthorization,
		},
		// 알림톡 템플릿 관리
		{
			path: 'managetemplate',
			name: 'managetemplate',
			component: () => import('@/views/mybiz/AlimTokTemplateMng/AlimTokTemplateMng'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 알림톡 템플릿 등록
		{
			path: 'registertemplate',
			name: 'registertemplate',
			component: () => import('@/views/mybiz/AlimTokTemplateMng/RegisterTemplate'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 알림톡 템플릿 상세 수정
		{
			path: 'detailtemplate',
			name: 'detailtemplate',
			component: () => import('@/views/mybiz/AlimTokTemplateMng/AlimTokTemplateDetail'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 발신프로필 관리
		{
			path: 'sendingprofile',
			name: 'sendingprofile',
			component: () => import('@/views/mybiz/SendingProfileMng/SendingProfile'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 주소록 관리
		{
			path: 'contactmng',
			name: 'contactmng',
			component: () => import('@/views/mybiz/ContactMng/ContactMng'),
			beforeEnter: checkAuthorization,
		},
		// 연락처 관리 - 태그 설정
		{
			path: 'contacttagedit',
			name: 'contacttagedit',
			component: () => import('@/views/mybiz/ContactMng/ContactTagEdit'),
			beforeEnter: checkAuthorization,
		},
		// 계좌관리 - 환불계좌 관리
		{
			path: 'refundaccountmng',
			name: 'refundaccountmng',
			props: true,
			component: () => import('@/views/mybiz/AccountMng/RefundAccountMng'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 계좌관리 - 전용계좌 관리
		{
			path: 'privateaccountmng',
			name: 'privateaccountmng',
			props: true,
			component: () => import('@/views/mybiz/AccountMng/PrivateAccountMng'),
			beforeEnter: subMemberCheckAuthorizationMaster,
		},
		// 인증 IP 관리
		{
			path: 'authip',
			name: 'authip',
			component: () => import('@/views/mybiz/AuthIp/AuthIpMng'),
			beforeEnter: checkAuthorization,
		},
	],
};
